import "./ArchiveSearch.css";
import { React, useState } from "react";
import { useAuth } from "../../../Security/AuthProvider";
import { useNotification } from '../../../Utils/Commons/Notification/NotificationContext';

const ArchiveSearch = ({ setArchiveMissions }) => {
  const [clientName, setClientName] = useState("");
  const [agentName, setAgentName] = useState("");
  const [operationName, setOperationName] = useState("");
  const [campaignName, setCampaignName] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { getCredentials } = useAuth();
  const { notifyError, notifySuccess } = useNotification();

  const fetchFilteredArchive = async () => {
    setIsLoading(true);
    try {
      const response = await fetch("/archive/get-all", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          company_name: getCredentials().company_name,
          company_password: getCredentials().company_password,
          clientName,
          agentName,
          operationName,
          campaignName,
        }),
      });
      const data = await response.json();
      if (data.error) {
        notifyError(data.error);
        return;
      }
      setArchiveMissions(data);
      notifySuccess('Archive supprimée/restaurée avec succès');
    } catch (error) {
      notifyError("Failed to fetch archives. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = () => {
    fetchFilteredArchive();
  };

  return (
    <div className="archive-search-bar">
      <h2>Rechercher des missions archivées</h2>
      <div className="archive-search-inputs">
        <input
          type="text"
          placeholder="Nom du client"
          value={clientName}
          onChange={(e) => setClientName(e.target.value)}
        />
        <input
          type="text"
          placeholder="Nom de l'agent"
          value={agentName}
          onChange={(e) => setAgentName(e.target.value)}
        />
        <input
          type="text"
          placeholder="Nom de l'opération"
          value={operationName}
          onChange={(e) => setOperationName(e.target.value)}
        />
        <input
          type="text"
          placeholder="Nom de la campagne"
          value={campaignName}
          onChange={(e) => setCampaignName(e.target.value)}
        />
        <button
          onClick={handleSearch}
          disabled={isLoading}
          className="search-button"
        >
          {isLoading ? "Chargement..." : "Rechercher"}
        </button>
      </div>
    </div>
  );
};

export default ArchiveSearch;
